<template>
    <section class="section-tec">
        <div class="content">
            <div class="title-section">科技赋能 快速响应</div>

            <div class="body">
                <swiper ref="mySwiper" class="swiper" :options="swiperOptions">
                    <div class="swiper-pagination" slot="pagination">123</div>

                    <swiper-slide v-for="(item, index) in webInfo.home.kjfnLsit" :key="index">
                        <div class="item">
                            <div class="left">
                                <img class="icon-fuhao" src="/images/hzc/home/icon-fuhao.png" alt="" />

                                <div class="title">
                                    {{item.title}}
                                </div>

                                <div class="text">
                                    {{item.text}}
                                </div>
                            </div>

                            <div class="right">
                                <img :src="item.img" alt="" />
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    data () {
        return {
            swiperOptions: {
                direction: 'vertical',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                mousewheel: true,
            },
        };
    },
    methods: {
        onSwiper (swiper) {
            console.log(swiper);
        },
        onSlideChange () {
            console.log('slide change');
        },

    },
    mounted () { 
    
    },
};
</script>

<style lang="scss" scoped>
.section-tec {
    background-image: url(/images/hzc/home/bg-tec.png);
    background-size: auto 559px;
    background-position: top center;
    background-repeat: no-repeat;

    .title-section {
        padding: 74px 0;
        color: white;
        font-weight: normal;
    }

    .swiper {
        height: 453px;

        &.swiper-container-vertical {
            & > .swiper-pagination-bullets {
                left: 0;

                ::v-deep {
                    .swiper-pagination-bullet {
                        background: white;
                        opacity: 0.7;
                        border-radius: 4px;

                        &.swiper-pagination-bullet-active {
                            opacity: 1;
                            height: 16px;
                        }
                    }
                }
            }
        }
    }

    .item {
        display: flex;
        color: white;

        .left {
            flex: 1;
            cursor: default;
            padding-left: 50px;

            .icon-fuhao {
                margin-bottom: 30px;
            }

            .title {
                font-size: 22px;
            }

            .text {
                font-size: 18px;
                margin-top: 40px;
                line-height: 36px;
            }
        }

        .right {
            margin-left: 46px;

            video {
                width: 806px;
            }

            img {
                width: 806px;
            }
        }
    }
}
</style>